import { render, staticRenderFns } from "./seller-assistant.vue?vue&type=template&id=40d0254a&scoped=true&"
import script from "./seller-assistant.vue?vue&type=script&lang=js&"
export * from "./seller-assistant.vue?vue&type=script&lang=js&"
import style0 from "./seller-assistant.vue?vue&type=style&index=0&id=40d0254a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d0254a",
  null
  
)

export default component.exports